<div>
	<app-create-employee-side-form
		[minify]="false"
		(onSubmit)="onSubmit($event)"
		(onCancel)="onCancel()"
		checkboxLabel="Same as Brokerage"
		[employee]="brokerage?.broker"
		[company]="brokerage"
		[firstName]="firstName"
		[lastName]="lastName"
	>
	</app-create-employee-side-form>
</div>
